import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useOtherObjectList } from "@/sx-layout/components/plotmap/components/objectList/hooks/useOtherObjectList";

type Props = {
  onZoomAreaRectangle: (_: number) => void;
  onZoomAreaPolygon: (_: number) => void;
  onZoomMark: (_: number) => void;
};

export const OtherObjectList: FC<Props> = ({ onZoomAreaRectangle, onZoomAreaPolygon, onZoomMark }) => {
  const { t } = useTranslation();
  const data = useOtherObjectList();

  return (
    <div className="h-[180px] overflow-y-auto mb-10">
      <table className="text-[13px] w-full border-separate" style={{ borderSpacing: 0 }}>
        <thead className="text-center">
          <tr className="sticky top-0 bg-[#ccc] [&>th]:border-solid [&>th]:border-[#888]">
            <th className="text-center border w-[240px]">{t("item")}</th>
            <th className="text-center border-r border-y w-[300px]">{t("content")}</th>
            <th className="text-center border-r border-y w-[60px]">{t("machine_operation_start")}</th>
            <th className="text-center border-r border-y w-[60px]">{t("machine_operation_end")}</th>
            <th className="text-center border-r border-y w-[180px]">{t("belonging")}</th>
            <th className="text-center border-r border-y w-[150px]">{t("machine_user")}</th>
            <th className="text-center border-r border-y w-[120px]">{t("contact")}</th>
            <th className="text-center border-r border-y">{t("note")}</th>
          </tr>
        </thead>
        <tbody className="bg-[#fff]">
          {data.map((object) => (
            <tr
              key={`${object.item}-${object.id}`}
              className="[&>td]:border-[#888] [&>td]:px-4 [&>td]:py-2 [&>td]:border-b [&>td]:border-solid"
            >
              <td className="border-x">
                <a
                  className="text-inherit hover:text-inherit hover:underline cursor-pointer"
                  onClick={() => {
                    object.item === "areaRectangle" && onZoomAreaRectangle(object.id);
                    object.item === "areaPolygon" && onZoomAreaPolygon(object.id);
                    object.item === "mark" && onZoomMark(object.id);
                  }}
                >
                  {object.label}
                </a>
              </td>
              <td className="border-r">
                {object.work_content && object.work_content.length >= 30
                  ? object.work_content.substring(0, 30) + "..."
                  : object.work_content}
              </td>
              <td className="border-r text-center">{object.use_start_hour}</td>
              <td className="border-r text-center">{object.use_end_hour}</td>
              <td className="border-r">{object.company_name}</td>
              <td className="border-r">{object.charge_user_name}</td>
              <td className="border-r">{object.phone_number}</td>
              <td className="border-r">
                {object.note && object.note.length >= 30 ? object.note.substring(0, 30) + "..." : object.note}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
